// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-textbox_textbox__EZz57 {
  /* Scale based on login box width (724px at 1536px screen = ~47vw) */
  /* Input should be ~80% of box width, responsive with clamp */
  width: clamp(200px, 32vw, 450px);
  padding: clamp(12px, 1.5vh, 18px) clamp(16px, 2vw, 24px);
  border: none;
  border-radius: 50px;
  background: linear-gradient(90deg, rgba(71, 95, 0, 0.5) 0%, #C4E369 100%);
  color: #DFDFDF;
  font-size: clamp(14px, 1.2vw, 18px);
}


.login-textbox_textbox__EZz57:focus {
  outline: none;
  /* Removes default focus outline */
  box-shadow: 0 0 4px 1px #C4E369;
  /* Optional: Focus glow effect */
}

.login-textbox_textbox__EZz57::placeholder {
  color: #dfdfdf96;
  /* Placeholder color to white */
  opacity: 1;
  /* Ensures full visibility */
  font-size: clamp(14px, 1.2vw, 18px);
}

.login-textbox_textbox-wrapper__Sg9ZF {
  margin-bottom: 0;
  border-radius: 50px;
  /* Rounded corners for the border */
  padding: 1px;
  /* Spacing for the border effect */
  background: linear-gradient(90deg, #C4E369 0%, rgba(71, 95, 0, 0.7) 100%);
  /* Gradient border */
}

.login-textbox_textbox-wrapper__Sg9ZF {
  position: relative;
  display: flex;
  align-items: center;
}

.login-textbox_textbox-wrapper-error__3lkCi {
  background: #ff0000;
}

.login-textbox_icon-wrapper__GoowV {
  position: absolute;
  right: clamp(12px, 1.5vw, 20px);
  cursor: pointer;
  font-size: clamp(1rem, 1.3vw, 1.4rem);
  color: #666;
}

.login-textbox_icon-wrapper__GoowV:hover {
  color: #000;
}


.login-textbox_label__s1BbA {
  color: black;
  display: block;
  margin-bottom: clamp(4px, 0.5vh, 8px);
  margin-left: clamp(12px, 1vw, 18px);
  margin-top: clamp(16px, 2.5vh, 30px);
  font-family: "FreckleFace", serif;
  font-weight: 400;
  font-style: normal;
  font-size: clamp(14px, 1.3vw, 20px);
}

.login-textbox_label-wrapper__KntPz {
  width: clamp(200px, 32vw, 450px);
  display: inline-block;
  border: none;
  background: none;
  text-align: left;
}

.login-textbox_error-text__7n7bI {
  color: #ff0000;
  font-size: clamp(0.7rem, 1vw, 0.9rem);
  margin: 0;
  margin-top: clamp(2px, 0.4vh, 5px);
}

/* Tablet screens */
@media (max-width: 1024px) {
  .login-textbox_label-wrapper__KntPz {
    width: clamp(250px, 60vw, 400px);
  }

  .login-textbox_textbox__EZz57 {
    width: clamp(250px, 60vw, 400px);
  }
}

/* Mobile screens */
@media (max-width: 768px) {
  .login-textbox_label-wrapper__KntPz {
    width: clamp(220px, 75vw, 350px);
  }

  .login-textbox_textbox__EZz57 {
    width: clamp(220px, 75vw, 350px);
  }
}`, "",{"version":3,"sources":["webpack://./src/UI/common/Inputs/login-textbox.module.css"],"names":[],"mappings":"AAAA;EACE,oEAAoE;EACpE,6DAA6D;EAC7D,gCAAgC;EAChC,wDAAwD;EACxD,YAAY;EACZ,mBAAmB;EACnB,yEAAyE;EACzE,cAAc;EACd,mCAAmC;AACrC;;;AAGA;EACE,aAAa;EACb,kCAAkC;EAClC,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,UAAU;EACV,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;EACnC,YAAY;EACZ,kCAAkC;EAClC,yEAAyE;EACzE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,YAAY;EACZ,cAAc;EACd,qCAAqC;EACrC,mCAAmC;EACnC,oCAAoC;EACpC,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,SAAS;EACT,kCAAkC;AACpC;;AAEA,mBAAmB;AACnB;EACE;IACE,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;AACF","sourcesContent":[".textbox {\n  /* Scale based on login box width (724px at 1536px screen = ~47vw) */\n  /* Input should be ~80% of box width, responsive with clamp */\n  width: clamp(200px, 32vw, 450px);\n  padding: clamp(12px, 1.5vh, 18px) clamp(16px, 2vw, 24px);\n  border: none;\n  border-radius: 50px;\n  background: linear-gradient(90deg, rgba(71, 95, 0, 0.5) 0%, #C4E369 100%);\n  color: #DFDFDF;\n  font-size: clamp(14px, 1.2vw, 18px);\n}\n\n\n.textbox:focus {\n  outline: none;\n  /* Removes default focus outline */\n  box-shadow: 0 0 4px 1px #C4E369;\n  /* Optional: Focus glow effect */\n}\n\n.textbox::placeholder {\n  color: #dfdfdf96;\n  /* Placeholder color to white */\n  opacity: 1;\n  /* Ensures full visibility */\n  font-size: clamp(14px, 1.2vw, 18px);\n}\n\n.textbox-wrapper {\n  margin-bottom: 0;\n  border-radius: 50px;\n  /* Rounded corners for the border */\n  padding: 1px;\n  /* Spacing for the border effect */\n  background: linear-gradient(90deg, #C4E369 0%, rgba(71, 95, 0, 0.7) 100%);\n  /* Gradient border */\n}\n\n.textbox-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.textbox-wrapper-error {\n  background: #ff0000;\n}\n\n.icon-wrapper {\n  position: absolute;\n  right: clamp(12px, 1.5vw, 20px);\n  cursor: pointer;\n  font-size: clamp(1rem, 1.3vw, 1.4rem);\n  color: #666;\n}\n\n.icon-wrapper:hover {\n  color: #000;\n}\n\n\n.label {\n  color: black;\n  display: block;\n  margin-bottom: clamp(4px, 0.5vh, 8px);\n  margin-left: clamp(12px, 1vw, 18px);\n  margin-top: clamp(16px, 2.5vh, 30px);\n  font-family: \"FreckleFace\", serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: clamp(14px, 1.3vw, 20px);\n}\n\n.label-wrapper {\n  width: clamp(200px, 32vw, 450px);\n  display: inline-block;\n  border: none;\n  background: none;\n  text-align: left;\n}\n\n.error-text {\n  color: #ff0000;\n  font-size: clamp(0.7rem, 1vw, 0.9rem);\n  margin: 0;\n  margin-top: clamp(2px, 0.4vh, 5px);\n}\n\n/* Tablet screens */\n@media (max-width: 1024px) {\n  .label-wrapper {\n    width: clamp(250px, 60vw, 400px);\n  }\n\n  .textbox {\n    width: clamp(250px, 60vw, 400px);\n  }\n}\n\n/* Mobile screens */\n@media (max-width: 768px) {\n  .label-wrapper {\n    width: clamp(220px, 75vw, 350px);\n  }\n\n  .textbox {\n    width: clamp(220px, 75vw, 350px);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textbox": `login-textbox_textbox__EZz57`,
	"textbox-wrapper": `login-textbox_textbox-wrapper__Sg9ZF`,
	"textbox-wrapper-error": `login-textbox_textbox-wrapper-error__3lkCi`,
	"icon-wrapper": `login-textbox_icon-wrapper__GoowV`,
	"label": `login-textbox_label__s1BbA`,
	"label-wrapper": `login-textbox_label-wrapper__KntPz`,
	"error-text": `login-textbox_error-text__7n7bI`
};
export default ___CSS_LOADER_EXPORT___;
